export default __webpack_public_path__ + "static/Fig 10 - Security Fence Detail-478ff0c21c24c8b39dd0ec639f8d0082.pdf";